import React from "react";
import "../../styles/components/facultyProfile/facultyProfileCard.scss";

export default function FacultyProfileCard({ name, image }) {
  return (
    <div className="faculty-profile-card">
      <div className="avatar-container">
        <img
          src={
            image ||
            "https://upload.wikimedia.org/wikipedia/commons/7/7c/Profile_avatar_placeholder_large.png?20150327203541"
          }
          alt="Profile Pic"
          className="avatar-image"
        />
      </div>
      <span className="name">{name}</span>
    </div>
  );
}
